import Vue from 'vue'
import Vuex from 'vuex'
import { chat } from './modules/chat'
import { project } from './modules/project'
import { settings } from './modules/settings'
import { sync } from './modules/sync'
import { health } from './modules/health'
import { support } from './modules/support'


Vue.use(Vuex)


export default new Vuex.Store({
  modules: {
    chat,
    project,
    settings,
    sync,
    health,
    support,
  }
})